import React from 'react';

/**
 * Static SVG stand-in for the "Table" block, shown on its palette card in the v2
 * editor: a card with a title, a filled header row and rows of outlined cells.
 * Wireframe style, matching the other `*PreviewGraphic` components.
 */

const CARD_X = 30;
const CARD_Y = 30;
const CARD_W = 1120;
const PAD = 28;
const INNER_LEFT = CARD_X + PAD;
const INNER_W = CARD_W - PAD * 2;
const COLS = 4;
const COL_STEP = INNER_W / COLS;
const ROW_TOP = CARD_Y + 156;
const ROW_STEP = 66;
const BODY_ROWS = 4;

const BODY_W = [
  [170, 220, 150, 190],
  [195, 215, 205, 185],
  [150, 210, 185, 200],
  [205, 160, 140, 195],
];

const FOOTER_Y = ROW_TOP + BODY_ROWS * ROW_STEP + 6;
const CARD_H = FOOTER_Y + 30 + PAD - CARD_Y;

function BodyRow({ index }: { index: number }) {
  const top = ROW_TOP + index * ROW_STEP;
  return (
    <g>
      {BODY_W[index].map((w, col) => (
        <rect
          key={col}
          x={INNER_LEFT + col * COL_STEP}
          y={top + 16}
          width={w}
          height="30"
          rx="15"
          fill="none"
          stroke="#B9C0C6"
          strokeWidth="1.5"
        />
      ))}
      <line
        x1={INNER_LEFT - 8}
        y1={top + ROW_STEP}
        x2={INNER_LEFT + INNER_W + 8}
        y2={top + ROW_STEP}
        stroke="#E7E8E4"
        strokeWidth="1.5"
      />
    </g>
  );
}

export default function TablePreviewGraphic() {
  return (
    <svg
      viewBox={`0 0 1180 ${CARD_Y + CARD_H + 20}`}
      width="100%"
      role="img"
      aria-label="Table block: a title, a header row and rows of cells"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block' }}
    >
      <rect
        x={CARD_X}
        y={CARD_Y}
        width={CARD_W}
        height={CARD_H}
        rx="20"
        fill="#F1F2EF"
        stroke="#E4E4E0"
      />
      <rect x={INNER_LEFT} y={CARD_Y + 28} width="290" height="40" rx="20" fill="#BEC6CC" />
      {Array.from({ length: COLS }).map((_, col) => (
        <rect
          key={col}
          x={INNER_LEFT + col * COL_STEP}
          y={CARD_Y + 92}
          width="205"
          height="34"
          rx="17"
          fill="#BEC6CC"
        />
      ))}
      <line
        x1={INNER_LEFT - 8}
        y1={CARD_Y + 140}
        x2={INNER_LEFT + INNER_W + 8}
        y2={CARD_Y + 140}
        stroke="#E7E8E4"
        strokeWidth="2"
      />
      {Array.from({ length: BODY_ROWS }).map((_, index) => (
        <BodyRow key={index} index={index} />
      ))}
      <rect
        x={INNER_LEFT}
        y={FOOTER_Y}
        width="560"
        height="30"
        rx="15"
        fill="none"
        stroke="#B9C0C6"
        strokeWidth="1.5"
      />
    </svg>
  );
}
